// customs-clearance-detail.model.ts
import {CustomsClearanceServiceVariant} from "./customs-clearance-service-variant.model";
import {CustomsClearanceService} from "./customs-clearance-service.model";
import {CustomsClearanceHeader} from "./customs-clearance-header.model";

export class CustomsClearanceDetail {
    clearanceDetailID?: number;
    clearanceHeader?: CustomsClearanceHeader;
    lineNumber: number;
    service?: CustomsClearanceService;
    variant?: CustomsClearanceServiceVariant;
    description: string;
    comments?: string;
    quantity: number;
    rate: number;
    amount: number;
    vat_percentage?: number;
    vat_amount?: number;
    totalAmount?: number;
    buyingAmount?: number;
    sellingAmount?: number;
    productId?: number;
    productVariantId?: number;
    operationalCode?: string;
    productCodeSnapshot?: string;
    productNameSnapshot?: string;
    variantCodeSnapshot?: string;
    variantNameSnapshot?: string;
    currencyCodeSnapshot?: string;
    taxRateSnapshot?: number;
    incomeAccountId?: number;
    expenseAccountId?: number;
    buyingPriceOverridden?: boolean;
    sellingPriceOverridden?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    owningCompanyId: number;

}
